module.exports = __webpack_public_path__ + "static/media/collaboration-share.4a0fd520.svg";